module.exports = __webpack_public_path__ + "img/how_shop_3_en.151fef77.png";